// extracted by mini-css-extract-plugin
export default {"box":"styles_box__cxcO8","box-header":"styles_box-header__gkZlu","box-info":"styles_box-info__r8qJ8","description":"styles_description__55nAW","note":"styles_note__UFDj1"};